import React, { useState } from 'react';
import { Button, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

interface ShareCodeProps {
  code: string;
}

const ShareCode: React.FC<ShareCodeProps> = ({ code }) => {
  const [copied, setCopied] = useState(false);

  // Referans kodunu kopyalama fonksiyonu
  const handleCopy = () => {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      message.success('Kod kopyalandı!');
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => {
      message.error('Kopyalama başarısız oldu');
    });
  };

  return (
    <Button
      icon={<CopyOutlined />}
      onClick={handleCopy}
      type={copied ? 'primary' : 'default'}
      size="large"
    >
      {copied ? 'Kopyalandı!' : 'Kopyala'}
    </Button>
  );
};

export default ShareCode;

